/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Foundation components are not intended to be edited to
 * satisfy specific use cases. If this component does not
 * do what you need it to, please reach out to a frontend
 * engineer before creating a new component or making
 * unapproved changes to this file.
 *
 * @author Nathan Buchar <nathan.buchar@hellosign.com>
 */

import React from 'react';
import classnames from 'classnames';

import { TableContext, SelectedContext } from '.';

import styles from './table.scss';

export type TableRowPropTypes = React.BaseHTMLAttributes<HTMLTableRowElement> & {
  eventKey?: string,
  disabled?: boolean,
};

function TableRow({
  className = '',
  eventKey,
  onClick,
  children,
  disabled,
  ...props
}: TableRowPropTypes) {
  const activeKey = React.useContext(TableContext);
  const onSelect = React.useContext(SelectedContext);

  const handleClick = React.useCallback((evt) => {
    const newActiveKey = activeKey === eventKey ? null : eventKey;
    if (!disabled) {
      if (onSelect) onSelect(newActiveKey);
      // Execute standard onClick event.
      if (onClick) onClick(evt);
    }
  }, [activeKey, eventKey, onSelect, onClick, disabled]);

  return (
    <tr
      data-qa-ref="table-row"
      className={classnames(styles.tableRow, className, {
        [styles.isSelected]: activeKey === eventKey,
        [styles.disabled]: disabled,
      })}
      onClick={handleClick}
      {...props}
    >
      {children}
    </tr>
  );
}

export default TableRow;
